export default __webpack_public_path__ + "asset/img/shop-logo/7~f09941be.png";